var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDestinationDownloadDisplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33332 5C8.8913 5 8.46737 5.17559 8.15481 5.48816C7.84225 5.80072 7.66666 6.22464 7.66666 6.66667V25.3333C7.66666 25.7754 7.84225 26.1993 8.15481 26.5118C8.46737 26.8244 8.8913 27 9.33332 27H22.6667C23.1087 27 23.5326 26.8244 23.8452 26.5118C24.1577 26.1993 24.3333 25.7754 24.3333 25.3333V11.6667H20C19.3812 11.6667 18.7877 11.4208 18.3501 10.9832C17.9125 10.5457 17.6667 9.95217 17.6667 9.33333V5H9.33332ZM19.6667 6.41421L22.9191 9.66667H20C19.9116 9.66667 19.8268 9.63155 19.7643 9.56904C19.7018 9.50652 19.6667 9.42174 19.6667 9.33333V6.41421ZM6.7406 4.07394C7.42823 3.38631 8.36086 3 9.33332 3H18.6667C18.9319 3 19.1862 3.10536 19.3738 3.29289L26.0404 9.95956C26.228 10.1471 26.3333 10.4015 26.3333 10.6667V25.3333C26.3333 26.3058 25.947 27.2384 25.2594 27.9261C24.5717 28.6137 23.6391 29 22.6667 29H9.33332C8.36086 29 7.42823 28.6137 6.7406 27.9261C6.05296 27.2384 5.66666 26.3058 5.66666 25.3333V6.66667C5.66666 5.69421 6.05296 4.76158 6.7406 4.07394Z",
    fill: "#3A4369"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestinationDownloadDisplay);
export default __webpack_public_path__ + "static/media/destination-download-display.d5360f91c6a22a1b74d85b80cc11ffa7.svg";
export { ForwardRef as ReactComponent };